import { Flex, Typography } from "antd";
import { useMemo } from "react";
import { useTrackingOp } from "../../../../contexts/TrackingOpContext";
import { datetime } from "../../../../util/library/datetime";
import { EXECUTION_TYPE, OP_RUNNING_MODE } from "../../../../util/varibles/constants";
import { stepNameV2 } from "../../../../util/varibles/global";
import { IActivityLog, IHarvest2 } from "../../../../util/varibles/interface";
import FinishStepButton from "../FinishStepButton";
import Tanks from "./Tanks";

export default function ArrivingToFactory({ log, prev, stepIndex }: { log: IActivityLog, prev: IActivityLog, stepIndex: number }) {
    const [execution_type] = useTrackingOp(state => state.op?.operation.execution_type);
    const [op_running_mode = OP_RUNNING_MODE.NORMAL] = useTrackingOp(state => (state.op?.operation as IHarvest2).op_running_mode);
    const name = stepNameV2(log.key);
    const { real_start_time, depature_time } = log;
    const time = depature_time || real_start_time;
    const { real_sub_steps = [], real_finish_time: prevFinishTime } = prev;
    const isPrevDone = useMemo(() => {
        if (execution_type !== EXECUTION_TYPE.AUTO && !real_start_time) {
            if (op_running_mode === OP_RUNNING_MODE.DETAIL) {
                return real_sub_steps.length > 0 && real_sub_steps?.every(item => !!item.real_finish_time);
            }
            return !!prevFinishTime
        }
        return false;
    }, [execution_type, op_running_mode, prevFinishTime, real_start_time, real_sub_steps])

    return <>
        <div className="w-full">
            <Flex className="h-[45px] items-center" gap={6}>
                <Typography.Text type="secondary">Departure site: </Typography.Text>
                <Typography.Text>{time ? datetime(time).format("HH:mm, DD/MM") : "--"}</Typography.Text>
            </Flex>
            <div className="mt-3">
                <Tanks />
            </div>
        </div>
        {isPrevDone && <FinishStepButton
            name={name}
            payload={{ step_new: -1, current_process: stepIndex }}
            message="This will start the step. Time is logged via GPS, or from your action if GPS is unavailable."
        />}
    </>
}
